import { render, staticRenderFns } from "./DuplicateTrip.vue?vue&type=template&id=82647994&"
import script from "./DuplicateTrip.vue?vue&type=script&lang=js&"
export * from "./DuplicateTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports